import { motion } from 'framer-motion';
import { fadeUp, staggeredFadeIn } from '../../utils/animations';

const teamVARoles = [
    {
        label: 'Admin',
        headerBg: 'bg-[#2A9D8F]',
        roles: ['Office Manager', 'Listing Manager', 'Transaction Coordinator', 'Onboarding / Offboarding', 'Accountability', 'Bookkeeper'],
    },
    {
        label: 'Marketing',
        headerBg: 'bg-[#E76F51]',
        roles: ['Marketing Manager', 'Video Editor'],
    },
    {
        label: 'Sales',
        headerBg: 'bg-[#1B3A5C]',
        roles: ['Inside Sales Agent (Growth)', 'Inside Sales Agent (Recruiting)', 'Inside Sales Agent (Maintenance)'],
    },
];

export function TeamVARoles() {
    return (
        <section className="bg-navy-900 py-24 md:py-32" data-testid="team-va-roles">
            <div className="max-w-5xl mx-auto px-6 lg:px-12">
                <motion.div {...fadeUp} className="text-center mb-14">
                    <h2 className="font-montserrat font-bold text-3xl md:text-4xl text-white tracking-tight">
                        Team VA Roles
                    </h2>
                </motion.div>

                <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                    {teamVARoles.map((col, ci) => (
                        <motion.div
                            key={col.label}
                            {...staggeredFadeIn(ci * 0.1)}
                            data-testid={`team-role-col-${ci}`}
                        >
                            <div className={`${col.headerBg} rounded-full px-5 py-3 text-center mb-4`}>
                                <span className="text-white font-montserrat font-bold text-sm">{col.label}</span>
                            </div>
                            <div className="space-y-2">
                                {col.roles.map((role) => (
                                    <div key={role} className="bg-white/5 border border-white/15 rounded-full px-5 py-2.5 text-center">
                                        <span className="text-gray-300 text-sm">{role}</span>
                                    </div>
                                ))}
                            </div>
                        </motion.div>
                    ))}
                </div>
            </div>
        </section>
    );
}
